import * as R from 'ramda';
import { AmountDietTag, CaloriesDietTag, ConclusionDietTag, NutritionDietTagGoodJob, NutritionDietTagToImprove, ProcessedFoodsDietTagGoodJob, ProcessedFoodsDietTagToImprove, RatioDietTag } from 'src/types/dietTags';

var mapTags = function mapTags(suffix) {
  return R.pipe(R.keys, R.map(function (key) {
    return {
      value: key,
      text: '熱量過高，建議減少高脂或高糖食物',
      i18n: "".concat(suffix, ".").concat(key)
    };
  }));
};

export var DietTagsOptions = {
  calories: {
    text: '熱量',
    i18n: 'client_mgmt:diet_tags.calories.title',
    options: mapTags('client_mgmt:diet_tags.calories')(CaloriesDietTag)
  },
  ratio: {
    text: '飲食比例',
    i18n: 'client_mgmt:diet_tags.ratio.title',
    options: mapTags('client_mgmt:diet_tags.ratio')(RatioDietTag)
  },
  amount: {
    text: '飲食份量',
    i18n: 'client_mgmt:diet_tags.amount.title',
    options: mapTags('client_mgmt:diet_tags.amount')(AmountDietTag)
  },
  processed_foods: {
    text: '加工食品',
    i18n: 'client_mgmt:diet_tags.processed_foods.title',
    groupOptions: [{
      text: '建議改進',
      i18n: 'client_mgmt:normal.to_improve',
      options: mapTags('client_mgmt:diet_tags.processed_foods.to_improve')(ProcessedFoodsDietTagToImprove)
    }, {
      text: '正面標籤',
      i18n: 'client_mgmt:normal.positive_labels',
      options: mapTags('client_mgmt:diet_tags.processed_foods.positive_labels')(ProcessedFoodsDietTagGoodJob)
    }]
  },
  nutrition: {
    text: '營養成分',
    i18n: 'client_mgmt:diet_tags.nutrition.title',
    groupOptions: [{
      text: '建議改進',
      i18n: 'client_mgmt:normal.to_improve',
      options: mapTags('client_mgmt:diet_tags.nutrition.to_improve')(NutritionDietTagToImprove)
    }, {
      text: '正面標籤',
      i18n: 'client_mgmt:normal.positive_labels',
      options: mapTags('client_mgmt:diet_tags.nutrition.positive_labels')(NutritionDietTagGoodJob)
    }]
  },
  conclusion: {
    required: true,
    text: '結語及評論',
    i18n: 'client_mgmt:diet_tags.conclusion.title',
    options: mapTags('client_mgmt:diet_tags.conclusion')(ConclusionDietTag)
  }
};